exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a {\n  cursor: pointer; }\n\nnav {\n  text-align: center; }\n\n.pagination {\n  width: 100%;\n  display: inline-block;\n  text-align: center;\n  position: relative;\n  margin-bottom: 0; }\n\n.previous {\n  float: left; }\n\n.next {\n  float: right; }\n\n.page-number {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/communication/event-pager/event-pager.component.scss
// module id = ../../../../../src/app/communication/event-pager/event-pager.component.scss
// module chunks = main